import { render, staticRenderFns } from "./PowerBiSpecificRightsTable.vue?vue&type=template&id=2affc2e0&scoped=true"
import script from "./PowerBiSpecificRightsTable.vue?vue&type=script&lang=js"
export * from "./PowerBiSpecificRightsTable.vue?vue&type=script&lang=js"
import style0 from "./PowerBiSpecificRightsTable.vue?vue&type=style&index=0&id=2affc2e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2affc2e0",
  null
  
)

export default component.exports